import { FaRocket } from "@onemind-services-llc/react-icons-ng/fa";
import { GiTeamIdea } from "@onemind-services-llc/react-icons-ng/gi";
import {
  RiPassValidLine,
  RiUserSettingsFill,
} from "@onemind-services-llc/react-icons-ng/ri";

export const MIGRATION_CONSTANTS = {
  TITLE: "OneMind MOST Migration Workflow",
  ITEMS: [
    {
      icon: FaRocket,
      title: "Workload Assessment",
      text: "We evaluate your compute, storage, and networking footprint across AWS, Azure, or GCP to determine the optimal migration route.",
    },
    {
      icon: GiTeamIdea,
      title: "Design & Blueprinting",
      text: "We design your OpenStack environment, mapping VM templates, network models, and tenant policies for smooth cutover.",
    },
    {
      icon: RiUserSettingsFill,
      title: "Migration Execution",
      text: "Using trusted tooling (Terraform, CloudEndure, Boto3, AzCopy, etc.), we automate workload replication with minimal manual effort.",
    },
    {
      icon: RiPassValidLine,
      title: "Post-Migration Readiness",
      text: "We validate VM health, optimize resource allocation, and align monitoring/backup policies before go-live.",
    },
  ],
};
